import React from 'react';

import {translate} from 'iss/strings';

export function CloseButton({onClick, ...props}) {
  return <button onClick={onClick} type="button" className="close"
    aria-label={translate('common.close')} {...props}>
    <span aria-hidden="true">&times;</span>
  </button>;
}

export default CloseButton;



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/bootstrap/CloseButton.jsx